import styled from "styled-components";

export const Homecon = styled.div`
    margin: 0 20%;
@media(max-width:786px){
    margin:5%;
}

@media(min-width:787px) and (max-width:1400px){
    margin: 0 5%;
}
`